import { render, staticRenderFns } from "./BackManager.vue?vue&type=template&id=744d9078&scoped=true"
import script from "./BackManager.vue?vue&type=script&lang=js"
export * from "./BackManager.vue?vue&type=script&lang=js"
import style0 from "./BackManager.vue?vue&type=style&index=0&id=744d9078&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744d9078",
  null
  
)

export default component.exports